import { platformExecuteContentLimitLengthMap } from 'services/config/platform';
import { DescendantExecuteContext } from '../Scenario/PolicyForm/share';
import { getSegmentsLength } from 'components/TemplateEditor/Editor';

export const useGetTaskStatus = () => {
  return (task: DescendantExecuteContext, platform: General.PlatformUpperCase) => {
    const { [platform]: contentLimit } = platformExecuteContentLimitLengthMap;

    const { content, translatedContent } = task || {};
    const hasText = content && content.some((v) => v.type === 'paragraph');

    if (hasText) {
      const contentLength = getSegmentsLength(content, 'text');
      const translatedContentLength = getSegmentsLength(translatedContent, 'text');

      if (contentLength === 0) {
        return 'wait';
      }

      if (contentLength > contentLimit || translatedContentLength > contentLimit) {
        return 'wait';
      }

      return 'finish';
    }

    return 'wait';
  };
};
